import PropTypes from 'prop-types';
import React from 'react';
import styles from './styles.scss';

const CardTitle = props => (<div>
  <section className={styles.section}>
    <div className={styles.titleContainer}>
      <div>
        <div className={styles.mainTitle}>
          <span className={styles.boldWord}>{props.title}</span>
        </div>
        <span className={styles.mainSubtitle}>{props.subtitle}</span>
      </div>
      {props.children}
    </div>
  </section>
  {props.divider &&
  <hr className={styles.dividerLine} />
  }
</div>);

CardTitle.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  children: PropTypes.element,
  divider: PropTypes.bool,
};

export default CardTitle;



// WEBPACK FOOTER //
// ./client/app/shared/components/CardTitle/index.jsx